import { QuickOption } from "./types";

export { LANGUAGE_CODES } from "../shared/constants";

// ─── Default quick options ─────────────────────────────
export const DEFAULT_QUICK_OPTIONS: QuickOption[] = [
    {
        id: "water",
        icon: "restaurant",
        title: {
            fr: "De l'eau",
            en: "Water",
            es: "Agua",
            it: "Acqua",
            nl: "Water",
            pt: "Água",
            de: "Wasser",
            ar: "ماء",
            ru: "Вода",
        },
        isDefault: true,
        enabled: true,
    },
    {
        id: "bill",
        icon: "receipt",
        title: {
            fr: "L'addition",
            en: "The bill",
            es: "La cuenta",
            it: "Il conto",
            nl: "De rekening",
            pt: "A conta",
            de: "Die Rechnung",
            ar: "الفاتورة",
            ru: "Счёт",
        },
        isDefault: true,
        enabled: true,
    },
    {
        id: "cutlery",
        icon: "restaurant",
        title: {
            fr: "Couvert supplémentaire",
            en: "Extra cutlery",
            es: "Cubierto adicional",
            it: "Posate extra",
            nl: "Extra bestek",
            pt: "Talher extra",
            de: "Zusätzliches Besteck",
            ar: "أدوات مائدة إضافية",
            ru: "Дополнительные приборы",
        },
        isDefault: true,
        enabled: true,
    },
    {
        id: "clean",
        icon: "check",
        title: {
            fr: "Nettoyer la table",
            en: "Clean the table",
            es: "Limpiar la mesa",
            it: "Pulire il tavolo",
            nl: "Tafel schoonmaken",
            pt: "Limpar a mesa",
            de: "Tisch reinigen",
            ar: "تنظيف الطاولة",
            ru: "Убрать стол",
        },
        isDefault: true,
        enabled: true,
    },
    {
        id: "sauce",
        icon: "restaurant",
        title: {
            fr: "Sauce/condiment",
            en: "Sauce/condiment",
            es: "Salsa/condimento",
            it: "Salsa/condimento",
            nl: "Saus/kruiden",
            pt: "Molho/condimento",
            de: "Soße/Gewürz",
            ar: "صلصة/توابل",
            ru: "Соус/приправа",
        },
        isDefault: true,
        enabled: true,
    },
    {
        id: "other",
        icon: "help",
        title: {
            fr: "Autre demande",
            en: "Other request",
            es: "Otra solicitud",
            it: "Altra richiesta",
            nl: "Ander verzoek",
            pt: "Outro pedido",
            de: "Andere Anfrage",
            ar: "طلب آخر",
            ru: "Другой запрос",
        },
        isDefault: true,
        enabled: true,
    },
];
